import React from "react";
import { Form, Pagination } from "react-bootstrap";

const CustomPagint = (props) => {
  /*Paginación*/
  const prev = () => {
    if (props.currentPage <= 0) props.setCurrentPage(0);
    else props.setCurrentPage(props.currentPage - 1);

    const oOffset = props.offset - props.limit;
    props.setOffset(oOffset);
    props.pagFunc(oOffset);
  };

  const next = () => {
    if (props.currentPage >= props.pages) {
      props.setCurrentPage(props.pages);
    } else {
      props.setCurrentPage(props.currentPage + 1);
    }
    const oOffset = props.offset + props.limit;
    props.setOffset(oOffset);
    props.pagFunc(oOffset);
  };

  const last = () => {
    props.setCurrentPage(props.pages);
    const oOffset = props.pages * props.limit - props.limit;
    props.setOffset(oOffset);
    props.pagFunc(oOffset);
  };

  const first = () => {
    props.setCurrentPage(1);
    const oOffset = 0;
    props.setOffset(oOffset);
    props.pagFunc(oOffset);
  };

  const onChangeLimit = (value) => {
    const oLimit = parseInt(value);
    const oOffset = 0;
    props.setLimit(oLimit);
    props.setOffset(oOffset);
    props.setCurrentPage(1);
    props.pagFunc(oOffset, oLimit);
  };
  /*fin paginación*/
  return (
    <Pagination className={`${props.jContent ? props.jContent : 'justify-content-sm-end'} justify-content-start align-items-center flex-wrap px-md-4 px-2`}>
      <small className="m-0 mr-2">Filas por página:</small>
      <Form.Control
        style={{ width: "3.5rem" }}
        as="select"
        size="sm"
        value={props.limit}
        onChange={(e) => onChangeLimit(e.target.value)}
      >
        <option value="10">10</option>
        <option value="20">20</option>
        <option value="30">30</option>
        <option value="50">50</option>
        <option value="100">100</option>
        <option value="150">150</option>
        <option value="250">250</option>
        <option value="500">500</option>
      </Form.Control>
      <small className="m-0 mx-2">
        {`${
          String(props.offset) +
          "-" +
          String(
            props.currentPage * parseInt(props.limit) > props.dataLenght
              ? props.dataLenght
              : props.currentPage * parseInt(props.limit)
          )
        } de ${props.dataLenght}`}
      </small>
      <Pagination.First
        className="custom-pagination-button-first"
        disabled={props.currentPage === 1 || props.pages === 1}
        onClick={() => first()}
      />
      <Pagination.Item
        onClick={() => prev()}
        disabled={props.currentPage === 1 || props.pages === 1}
      >
        Anterior
      </Pagination.Item>
      <Pagination.Item
        disabled={
          props.currentPage === props.pages ||
          props.pages === 1 ||
          props.pages === 0
        }
        onClick={() => next()}
      >
        Siguiente
      </Pagination.Item>
      <Pagination.Last
        className="custom-pagination-button-last"
        disabled={
          props.currentPage === props.pages ||
          props.pages === 1 ||
          props.pages === 0
        }
        onClick={() => last()}
      />
    </Pagination>
  );
};

export default CustomPagint;
